<template>
  <div class="error">
    <div>
      <h1>抱歉，找不到此页面~</h1>
      <h2>Sorry, the site now can not be accessed.</h2>
      <p>你请求访问的页面，暂时找不到，工程师正在努力创造，谢谢！</p>
      <div class="button_group">
        <button @click="toIndex">返回首页</button>
        <button @click="toLast">返回上一页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toIndex() {
      this.$router.push({ name: 'index' })
    },
    toLast() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.error {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    padding: 25px 45px;
    border: 1px dashed #989898;
    h1 {
      font-size: 44px;
      color: #666;
      margin-bottom: 15px;
    }
    h2 {
      font-size: 16px;
      color: #666;
      margin-bottom: 15px;
    }
    p {
      font-size: 16px;
      color: #989898;
      margin-bottom: 20px;
    }
    .button_group {
      button {
        width: 100px;
        line-height: 35px;
        font-size: 16px;
        color: #fff;
        background: #0487d1;
        border: 1px solid #0487d1;
        transition: 0.5s ease all;
        &:hover {
          color: #0487d1;
          background: #fff;
        }
        &:first-child {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
